import { all } from 'redux-saga/effects';
import persistSaga from './persistSaga';
import commonSaga from './commonSaga';

export default function* root() {
    yield all([persistSaga(), commonSaga()]);
}
